import { Button, Grid } from '@material-ui/core'
import Typography from '@material-ui/core/Typography'
import { FC, useRef, useState } from 'react'
import Dialog from '../../../control/dialog/dialog'
import useLoading from '../../../control/loading/useLoading'
import useTranslate from '../../../i18n/useTranslate'
import useCommittees from '../shareLogic/useCommittees'
import { useCommitteeStyles } from './committeeStyles'

const ExpertInfo: FC<{ committeeID: number }> = ({ committeeID }) => {
    const classes = useCommitteeStyles()
    const expertInfoRef = useRef<Record<string, Function>>()
    const translate = useTranslate()
    const committeeHook = useCommittees()
    const loadingHook = useLoading()
    const [expertInfoList, setExpertInfoList] = useState<
        {
            nameTH: string
            nameEN: string
        }[]
    >([])

    const bindExpertInfoRef = (func: Record<string, Function>) => {
        expertInfoRef.current = { ...func }
    }

    const openExpertInfo = async () => {
        loadingHook.loadingOpen()
        const expertInfo = await committeeHook.getExpertInfo(committeeID)
        if (expertInfo.result) {
            setExpertInfoList(expertInfo.result)
        }
        loadingHook.loadingClose()
        expertInfoRef.current?.openDialog()
    }

    const closeExpertInfo = () => {
        expertInfoRef.current?.closeDialog()
    }

    return (
        <>
            <Typography variant="body2" className={classes.linkLabel} onClick={() => openExpertInfo()}>
                {translate.get('LABEL.VIEW_EXPERTISE_INFO')}
            </Typography>
            <Dialog
                onRef={bindExpertInfoRef}
                type=""
                title={translate.get('LABEL.EXPERTISE')}
                content={
                    <Grid container spacing={2}>
                        {expertInfoList?.length > 0 ? (
                            expertInfoList?.map((data, index) => (
                                <Grid item xs={12} key={index}>
                                    <Typography variant="body2">
                                        {translate.languageStore.currentLanguage === translate.languageKey.th
                                            ? data.nameTH
                                            : data.nameEN}
                                    </Typography>
                                </Grid>
                            ))
                        ) : (
                            <Grid item xs={12}>
                                <Typography variant="body2">{translate.get('LABEL.NO_DATA_FOUND')}</Typography>
                            </Grid>
                        )}
                        <Grid item xs={12} style={{ position: 'sticky', bottom: '-8px', backgroundColor: '#fff' }}>
                            <Grid container justifyContent="center">
                                <Grid item xs="auto">
                                    <Button color="primary" variant="outlined" onClick={closeExpertInfo}>
                                        {translate.get('BUTTON.CLOSE_MODAL')}
                                    </Button>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                }
            />
        </>
    )
}

export default ExpertInfo
